export const ClientName = {
    COOLBET: 'coolbet',
    DEMO: 'demo',
    LOCKER01: 'l1',
    IVC: 'ivc',
    WYNNBET: 'wynnbet',
    WYNNBET_NEVADA: 'wynnbet-nv',
    FONTAINEBLEAU: 'fontainebleau-nv',
    STATION: 'station',
    ORCA: 'orca',
    PLAYTEST: 'playtest',
} as const;
